<template>
  <div class="">
    <div class="container lnb d_container">
      <div class="contents_wrap no_height">
        <div class="contents list-container">
          <div class="title">탈퇴회원</div>
            <div>
                <member-list-component :member-type="`quit`"></member-list-component>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
  name: "MemberQuit",
  mixins: [],
  components: {
    MemberListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
